import { render, staticRenderFns } from "./TaxableRebateLimitGrid.vue?vue&type=template&id=6c636697"
import script from "./TaxableRebateLimitGrid.vue?vue&type=script&lang=js"
export * from "./TaxableRebateLimitGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports